<template>
    <div>
        <div class="card card-custom shadow-lg" :class="disabled ? 'opacity-50' : ''">
            <div class="card-header bg-primary bg-radial-gradient-primary">
                <div class="card-title text-light-white">
                    {{ title }}
                </div>
                <div class="my-auto"><i :class="iconClass" class="fa-2x text-light-white"></i></div>
            </div>
            <div class="card-body h-200px row align-content-between">
                <div class="col-12">
                    {{ text }}
                </div>
                <Link as="button" v-if="isInertiaLink" :class="disabled ? 'pointer-events-none' : ''" :href="link" class="btn btn-primary mt-3 h-40px">
                    {{ title }}
                </Link>
                <a v-else :href="link" :target="targetBlank ? '_blank' : '_self'" class="btn btn-primary mt-3 h-40px">
                    {{ title }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';

export default {
    name: 'DashboardCard',
    components: {
        Link
    },
    props: {
        title: String,
        text: String,
        iconClass: String,
        link: String,
        disabled: Boolean,
        isInertiaLink: Boolean,
        targetBlank: {
            type: Boolean,
            default: false,
        }
    },
};
</script>
